/* eslint-disable max-statements */
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useCreateReviews from "hooks/useCreateReviews";
import useReviews from "hooks/useReviews";
import useUser from "hooks/useUser";
import { memo, useCallback, useMemo, useState } from "react";
import Edit from "./Edit";
const DEFAULT_IS_COMPACT = true;
const usePrepareComponent = () => {
    const { clear, setIsMatchTitle, setReview, setIsUHD, state } = useReviews();
    const { isAdmin } = useUser();
    const [isCompact, setIsCompact] = useState(DEFAULT_IS_COMPACT);
    const { areReviewsLoading } = useCreateReviews();
    const onClear = useCallback((serviceName) => () => {
        clear(serviceName);
    }, [clear]);
    const onSetReview = useCallback((serviceName) => (review) => {
        setReview(review, serviceName);
    }, [setReview]);
    const isMatchTitleCheckboxProps = useMemo(() => ({
        checked: state.isMatchTitle,
        isDisabled: areReviewsLoading,
        onChange: () => {
            setIsMatchTitle(!state.isMatchTitle);
        }
    }), [areReviewsLoading, state.isMatchTitle, setIsMatchTitle]);
    const isUHDCheckboxProps = useMemo(() => ({
        checked: state.isUHD,
        isDisabled: areReviewsLoading,
        onChange: () => {
            setIsUHD(!state.isUHD);
        }
    }), [areReviewsLoading, state.isUHD, setIsUHD]);
    const isCompactCheckboxProps = useMemo(() => ({
        checked: isCompact,
        isDisabled: areReviewsLoading,
        onChange: () => {
            setIsCompact(!isCompact);
        }
    }), [areReviewsLoading, isCompact]);
    const reviewsControlCheckboxesProps = useMemo(() => ({
        isAdmin,
        isCompactCheckboxProps,
        isMatchTitleCheckboxProps,
        isUHDCheckboxProps
    }), [
        isAdmin,
        isCompactCheckboxProps,
        isMatchTitleCheckboxProps,
        isUHDCheckboxProps
    ]);
    return {
        areReviewsLoading,
        avForums: state.avForums.selected,
        avNirvana: state.avNirvana.selected,
        avsForum: state.avsForum.selected,
        bluRay: state.bluRay.selected,
        bluRayAuthority: state.bluRayAuthority.selected,
        digitalBits: state.digitalBits.selected,
        doBlu: state.doBlu.selected,
        hidefDigest: state.hidefDigest.selected,
        highDefDiscNews: state.highDefDiscNews.selected,
        homeTheaterForum: state.homeTheaterForum.selected,
        onClear,
        onSetReview,
        reviewsControlCheckboxesProps,
        theaterByte: state.theaterByte.selected,
        whySoBlu: state.whySoBlu.selected
    };
};
export default prepareComponent(usePrepareComponent)(memo(Edit));
